import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../components/button/Button';
import './SucessAccountConfirmation.css';
import { useBrandContext } from "../../context/BrandContext";

const SucessAccountConfirmation = () => {   
    const navigate = useNavigate();
    const location = useLocation();

    const brandContext = useBrandContext();
    // const routePaths = location.pathname.split('/');

    return (
        <div className='sucess-switch-password-wrapper'>
            <div className="sucess-switch-password-container">
                <div className='sucess-switch-password-fields'>
                    <span className='sucess-switch-password-title'>Email confirmado!</span>
                    <span className='sucess-switch-password-subtitle'>Tudo certo para o login no app</span>
                    <Button
                        style={{backgroundColor: brandContext.brandBgColor ? brandContext.brandBgColor: '#3CCC10', color: '#FFFFFF', marginTop: '33px'}}
                        type= 'button'
                        children = "Ir para login"
                        onClick={() => navigate(`/${brandContext.brandName}/login`)}
                    />
                </div>
            </div>
        </div>
    );
};

export default SucessAccountConfirmation;